import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { AppComponent } from './app.component';
import { UserService } from './users/user.service';

import { AppRoutingModule } from './app-routing/app-routing.module';
import { UsersComponent } from './users/users.component';
import { HelperService } from "./services/helper.service";
import { ExpiredGuard } from "./guards/expired.guard";
import { ScoreboardComponent } from './scoreboard/scoreboard.component';
import { ScoreboardService } from "./services/scoreboard.service";
import { SocketService } from "./services/socket.service";
import { QsleaderbaordComponent } from './qsleaderbaord/qsleaderbaord.component';
import { QsrugbyComponent } from './qsrugby/qsrugby.component';




@NgModule({
  declarations: [
    AppComponent,
    UsersComponent,
    ScoreboardComponent,
    QsleaderbaordComponent,
    QsrugbyComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    AppRoutingModule
  ],
  providers: [UserService, HelperService, ExpiredGuard, ScoreboardService, SocketService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts